import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { BottomSheetBody, BottomSheetHeader, BottomSheetHeaderTitle, Flex, FlexCenter, Separator, SpaceBetween, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { BackButton } from "../../../../../components/BackButton/BackButton";
import { TransferFlowReviewItems } from "../TransferFlowReviewItems";
import { TransferFlowTimeline } from "../TransferFlowTimeline";
import { TransferFlowReview_itemFragment } from "./TransferFlowReview.fragment";
export function TransferFlowReview(t0) {
  const $ = _c(41);
  const {
    onBack,
    onSuccess,
    onError,
    items: itemKeys,
    formValues
  } = t0;
  const t = useTranslations("wallet.TransferFlowReview");
  let t1;
  if ($[0] !== itemKeys) {
    t1 = itemKeys.map(_temp);
    $[0] = itemKeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  let t2;
  if ($[2] !== onBack) {
    t2 = () => onBack();
    $[2] = onBack;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BackButton />;
    t4 = <Separator className="h-4 text-secondary" orientation="vertical" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== formValues.items.length || $[7] !== t) {
    t5 = t("reviewTransfer", {
      count: formValues.items.length
    });
    $[6] = formValues.items.length;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <FlexCenter className="gap-3">{t3}{t4}{t5}</FlexCenter>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <BottomSheetHeader><BottomSheetHeaderTitle className="cursor-pointer" onClick={t2}>{t6}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("sendTo");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <TextBody weight="semibold">{t8}</TextBody>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== formValues.recipient.identifier) {
    t10 = <TextBody>{formValues.recipient.identifier}</TextBody>;
    $[18] = formValues.recipient.identifier;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <SpaceBetween className="h-[68px] items-center">{t9}{t10}</SpaceBetween>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Separator className="my-0.5" />;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== formValues || $[25] !== items) {
    t13 = <TransferFlowReviewItems formValues={formValues} items={items} />;
    $[24] = formValues;
    $[25] = items;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Separator className="my-0.5" />;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== formValues || $[29] !== items || $[30] !== onBack || $[31] !== onError || $[32] !== onSuccess) {
    t15 = <Flex className="w-full pt-4 pb-6"><TransferFlowTimeline formValues={formValues} items={items} onBack={onBack} onError={onError} onSuccess={onSuccess} /></Flex>;
    $[28] = formValues;
    $[29] = items;
    $[30] = onBack;
    $[31] = onError;
    $[32] = onSuccess;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t11 || $[35] !== t13 || $[36] !== t15) {
    t16 = <BottomSheetBody>{t11}{t12}{t13}{t14}{t15}</BottomSheetBody>;
    $[34] = t11;
    $[35] = t13;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16 || $[39] !== t7) {
    t17 = <>{t7}{t16}</>;
    $[38] = t16;
    $[39] = t7;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
}
function _temp(item) {
  return readFragment(TransferFlowReview_itemFragment, item);
}